import UncontrolledForm from "../../../../content/blog/react-form/components/UncontrolledForm.js";
import ControlledForm from "../../../../content/blog/react-form/components/ControlledForm.js";
import ValidationForm from "../../../../content/blog/react-form/components/ValidationForm.js";
import * as React from 'react';
export default {
  UncontrolledForm,
  ControlledForm,
  ValidationForm,
  React
};